class TablesLogic {
    DEFAULT_ITEMS_PAGE = 10;
}

export default TablesLogic;